import { Component } from '@angular/core';

@Component({
  selector: 'app-jd-study-info',
  templateUrl: './jd-study-info.component.html',
  styleUrls: ['./jd-study-info.component.scss']
})
export class JdStudyInfoComponent {
}
